import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyCustom',
    standalone: false
})
export class CurrencyCustomPipe implements PipeTransform {
  transform(value: number, numberOfDecimals: number= 2) {
    if (value !== undefined && value !== null) {
      if (value < 0) {
        return `(${this.formatNumber(value, numberOfDecimals).replace('-', '')}) $`;
      } else {
        return `${this.formatNumber(value, numberOfDecimals)} $`;
      }
    } else {
      return '';
    }
  }

  formatNumber(value:number, numberOfDecimals: number): string {
    return value
      .toFixed(numberOfDecimals)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      .replace(/,/g, ' ');
  }
}
